var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notices"},[_c('p-header',{attrs:{"title":"重要通知"}}),_c('div',{staticClass:"list"},_vm._l((_vm.notices),function(notice){return _c(notice.data.template,{key:notice.id,tag:"component",attrs:{"notice":notice}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }